import { render, staticRenderFns } from "./SpeedPage.vue?vue&type=template&id=13b3827e&"
import script from "./SpeedPage.vue?vue&type=script&lang=js&"
export * from "./SpeedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports